module.exports = __webpack_public_path__ + "static/media/samarth.faeac9fd.png";